// Types
import { RootState } from 'types/RootState.types';

export const getBasketUrlSelector = (state: RootState) => state.bff?.basketUrl || '';
export const getBrowseUrlSelector = (state: RootState) => state.bff?.browseUrl || '';
export const getSessionIdSelector = (state: RootState) => state.bff?.sessionId || '';
export const getSessionExpiryData = (state: RootState) => state.bff?.sessionExpiryData;
